<template>
    <div class="row">
            <div class="col-md-12 grid-pad">
                <DxDataGrid
                :data-source="Organizations"
                :allow-column-reordering="true"
                :allow-column-resizing="true"
                :column-auto-width="true"
                :show-borders="true"
                key-expr="OrganizationId"
                width="100%"
                :show-row-lines="true"
                :row-alternation-enabled="true">

                    <DxPaging :page-size="5" />
                    <DxHeaderFilter :visible="true" />
                    <DxFilterRow :visible="true" />
                    <DxEditing :allow-updating="true" :use-icons="true" mode="cell" />

                    <DxColumn
                    caption=""
                    data-type="boolean"
                    :visible="true"
                    alignment="center"
                    data-field="Send"
                    :allow-filtering="false" />

                    <DxColumn
                    caption="Περιφέρεια"
                    data-field="RegionDescription"
                    data-type="string"
                    width="20%"
                    alignment="left"
                    :allow-editing="false" />

                    <DxColumn
                    caption="Νομός"
                    data-field="CountyDescription"
                    data-type="string"
                    width="20%"
                    alignment="left"
                    :allow-editing="false" />

                    <DxColumn
                    caption="Δήμος"
                    data-field="MunicipalityDescription"
                    data-type="string"
                    width="20%"
                    alignment="left"
                    :allow-editing="false" />

                    <DxColumn
                    caption="Φορέας"
                    data-field="OrganizationDescription"
                    data-type="string"
                    :visible="true"
                    :allow-editing="false"
                    alignment="left"
                    width="30%" />

                    <DxSummary>
                        <DxTotalItem
                        column="OrganizationDescription"
                        summary-type="count" />
                    </DxSummary>

                </DxDataGrid>
            </div>
        </div>
</template>
<script>
import {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxTotalItem,
    DxSummary,
} from "devextreme-vue/data-grid";
export default {
    components:{
        DxDataGrid,
        DxSummary,
        DxTotalItem,
        DxColumn,
        DxFilterRow,
        DxHeaderFilter,
        DxPaging,
        DxEditing,
    },
    props:['organizations'],

    computed:{
        Organizations(){
            return this.organizations.filter(x=>x.Send == true)
        }
    }
}
</script>